import {
  TbBackpack,
  TbBuilding,
  TbBuildings,
  TbBus,
  TbClipboardText,
  TbCreditCard,
  TbEyeShare,
  TbNavigationQuestion,
  TbSearch,
  TbSchool,
  TbCertificate,
  TbShieldStar,
  TbInfoCircle,
  TbHelpCircle,
  TbTableExport,
  TbTableImport,
  TbInbox,
  TbUserShield,
  TbCalendarEvent,
  TbCopy,
  TbDeviceMobileMessage,
} from 'react-icons/tb';
import {
  LuIdCard,
  LuReceiptText,
  LuTicket,
  LuUndo2,
  LuUsersRound,
  LuTicketPlus,
  LuEye,
} from 'react-icons/lu';
import { PiArrowArcRightBold } from 'react-icons/pi';

export const IconEyeArrow = TbEyeShare;

export const IconOrganisations = TbBuildings;

export const IconOrganisation = TbBuilding;

export const IconTravellers = LuUsersRound;

export const IconTicket = LuTicket;

export const IconTicketPlus = LuTicketPlus;

export const IconReports = TbClipboardText;

export const IconBus = TbBus;

export const IconBackpack = TbBackpack;

export const IconYouthCard = LuIdCard;

export const IconGraduationCap = TbSchool;

export const IconUndo = LuUndo2;

export const IconSmartcard = TbCreditCard;

export const IconPaper = LuReceiptText;

export const IconOtherBearer = TbNavigationQuestion;

export const IconSearch = TbSearch;

export const IconPayers = TbCertificate;

export const IconSysadmin = TbShieldStar;

export const IconInfo = TbInfoCircle;

export const IconHelp = TbHelpCircle;

export const IconExportExcel = TbTableExport;

export const IconEye = LuEye;

export const IconDataImport = TbTableImport;

export const IconApplications = TbInbox;

export const IconDepartmentAdmin = TbUserShield;

export const IconSkip = PiArrowArcRightBold;

export const IconPeriods = TbCalendarEvent;

export const IconAppEmail = TbDeviceMobileMessage;

export const IconCopy = TbCopy;
